import React from 'react';
import SVGInline from 'react-svg-inline';

import inspectionNote from 'legacy/assets/svg-inline/inspection_note.svg';

import { CommentIcon as theme } from 'legacy/css-modules';

const CommentIcon = ({ hasComment }) => {
  return (
    <div className={theme.CommentIcon}>
      {hasComment && <div className={theme.CommentIconIndicator} />}
      <SVGInline height="30px" width="30px" svg={inspectionNote} />
    </div>
  );
};

export default CommentIcon;
